import React, { forwardRef } from "react";
import Select, { components } from "react-select";
import { Form } from "react-bootstrap";
import "./styles.css";

export const SelectField = forwardRef((props, ref) => {
  const { ValueContainer, Placeholder } = components;

  const CustomValueContainer = ({ children, ...props }) => {
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused}>
          {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null
        )}
      </ValueContainer>
    );
  };

  const {
    placeholder,
    options,
    selectedOption,
    setSelectedOption,
    valueText = 'value',
    labelText = 'label',
    error,
    focus,
    boxClass,
    className,
    classNamePrefix,
    disabled,
    errorClass = "",
  } = props;


  const invalid = !!(error);

  return (
    <div className={boxClass} ref={ref}>
      <Select
        className={`${className} ${disabled ? "disabledSelect" : ""}`}
        isDisabled={disabled}
        styles={{
          container: (base) => ({
            ...base,
            border: invalid ? "1px solid #dc3545" : base.border,
            borderRadius: "4px",
          }),
          valueContainer: (provided) => ({
            ...provided,
            overflow: "visible",
          }),
        }}
        components={{
          ValueContainer: CustomValueContainer,
        }}
        value={selectedOption}
        classNamePrefix={classNamePrefix}
        onChange={setSelectedOption}
        options={
          valueText === "value" && labelText === "label"
            ? options
            : options.map((item) => ({
              value: item[valueText],
              label: item[labelText],
            }))
        }
        placeholder={placeholder}
      />
      {invalid && (
        <p className={`${errorClass} invalid-feedback d-block`}>{error}</p>
      )}
    </div>
  );
});
